import { Col } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { DarkBackgroundTitle } from "../../../../Constants/Constants";
import { BorderColorData } from "../../../../Data/UiKits/HelperClasses";

const DarkBackground = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H5 className="mb-3">{DarkBackgroundTitle}</H5>
        {BorderColorData &&
          BorderColorData.map((item, index) => (
            <div className="helper-common-box" key={index}>
              <div className={`helper-box bg-${item.color}`} />
              <span>{`.bg-${item.color}`}</span>
            </div>
          ))}
      </div>
    </Col>
  );
};
export default DarkBackground;
